export default {
  resource: {
    disabledTip: '时长不符合该版位的要求',
    checkLabel: '全选',
    selection: '素材选择',
    checkDescribe: '已选中 {count} 个资产',
  },
  layout: {
    toPage: '去Playturbo解锁更多编辑操作。',
    media: '媒体渠道',
    size: '版位尺寸',
    horVideo: '横版视频',
    squareVideo: '方形视频',
    verVideo: '竖版视频',
    broadwise: '横向',
    square: '方形',
    direction: '纵向',
    icon: '图标',
    facebook: 'Facebook 快拍',
    dynamic: '动态版位',
    largeImage: '大图',
    squareImage: '方形大图',
    horImage: '大图竖版图',
    screenImage: '开屏图片',
    way: '适配方式',
    fillBlack: '全部填充黑边',
    outCrop: '全部超出裁剪',
    stretchFill: '全部拉伸填充',
    dimensions: '尺寸',
    materialFill: '素材填充方式',
    fillEdge: '自动填充',
    cropEdge: '自动裁剪',
    background: '背景',
    color: '纯色',
    vague: '模糊',
    image: '图片',
    backgroundColor: '背景色',
    sellColor: '智能取色',
    applyAll: '应用于所有素材',
    customLabel: '自定义',
    customSize: '尺寸（要求）',
    customDuration: '时长（要求）',
    inputTips: '视频尺寸只支持填写偶数。',
  },
  export: {
    cancel: '取 消',
    label: '导 出',
    tips: '请先勾选素材',
    title: '导出素材',
    scale: '比例 {ratio}，',
    measurement: '尺寸 {resolution}',
    duration: '，时长 {min}~{max}s',
    content: '已选择 {count} 个素材，确定导出吗？',
    success: '导出任务已添加至 XMP-工具-素材编辑',
    renderAndBack: '导出并返回编辑',
    renderAndClose: '导出并退出编辑',
    set: '导出设置',
  },
}
